import React from 'react'

const CoreComponent15 = ({content2,content3}) => {
  return (
     <div className="">

       
        <div className="row d-flex mt-70 mart justify-content-center ">
          {content2.map((val, i) => (
            <div key={i} className="col-md-6 mb-4 pb-3 mb-md-0 pb-md-0 text-center transform-rotate ">
              <div className="border-card p-3   h-100">
                <div className='img d-flex align-items-md-center justify-content-center'>
                <img src={val.icon} alt="" style={{ width: 40, height: 40 }} />

                </div>
                <div>
                  <h3 className="h3-heading lh-base fs-4 mb-2 mt-3 pt-1">{val.title}</h3>
                  <p className="h3-para lh-base fs-6">{val.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row mt-60 mart30 d-flex  justify-content-center ">
          {content3.map((val, i) => (
            <div key={i} className="col-lg-4 col-md-6  mb-4 mb-lg-0 pb-3 pb-lg-0">
              <div className="border-card p-3  h-100 me-3 text-center transform-rotate" >
              <div className='img d-flex align-items-md-center justify-content-center'>
                <img src={val.icon} alt="" style={{ width: 40, height: 40 }} />

                </div>
                <div>
                  <h3 className="h3-heading lh-base  fs-4 mb-2 mt-3 pt-1">{val.title}</h3>
                  <p className="h3-para lh-base fs-6">{val.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

         </div>
  )
}

export default CoreComponent15